import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Reveal } from "./Reveal";
import { Instagram, ArrowUpRight } from "lucide-react";

const PROFILE_URL = "https://www.instagram.com/oltre_ilconflitto";

export const InstagramSection = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/instagram/feed")
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]));
  }, []);

  return (
    <section id="instagram" data-testid="instagram-section" className="py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <p className="overline-tag mb-4">Instagram</p>
            <h2 className="font-serif font-semibold text-ink tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight">
              Riflessioni e parole, ogni settimana.
            </h2>
          </div>
          <a href={PROFILE_URL} target="_blank" rel="noopener noreferrer" data-testid="instagram-profile-cta"
            className="inline-flex items-center gap-2 rounded-full border border-ink/20 text-ink font-semibold px-6 py-3 hover:border-gold hover:text-golddeep transition-colors duration-300">
            <Instagram size={17} /> @oltre_ilconflitto
          </a>
        </Reveal>

        {items && items.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 lg:gap-6" data-testid="instagram-feed-grid">
            {items.slice(0, 6).map((post, i) => {
              const img = post.media_type === "VIDEO" ? post.thumbnail_url : post.media_url;
              return (
                <Reveal key={post.id} delay={i * 0.08}>
                  <a href={post.permalink} target="_blank" rel="noopener noreferrer" data-testid={`instagram-post-${i}`}
                    className="group block rounded-2xl overflow-hidden border border-ink/10 bg-white hover:border-gold/60 hover:-translate-y-1 transition-all duration-500">
                    {img && (
                      <div className="overflow-hidden">
                        <img src={img} alt={(post.caption || "Post Instagram").slice(0, 120)} loading="lazy"
                          className="aspect-square w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                      </div>
                    )}
                    {post.caption && (
                      <p className="p-4 text-xs sm:text-sm text-mist leading-relaxed line-clamp-3">{post.caption}</p>
                    )}
                  </a>
                </Reveal>
              );
            })}
          </div>
        ) : (
          <Reveal>
            <a href={PROFILE_URL} target="_blank" rel="noopener noreferrer" data-testid="instagram-fallback-card"
              className="group flex flex-col sm:flex-row items-center gap-6 rounded-3xl border border-gold/40 bg-goldlight/40 px-8 py-10 hover:border-gold transition-colors duration-300">
              <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-ink text-gold shrink-0 group-hover:scale-105 transition-transform duration-300">
                <Instagram size={26} />
              </span>
              <span className="text-center sm:text-left">
                <span className="block font-serif font-semibold text-ink text-xl sm:text-2xl">
                  Segui @oltre_ilconflitto su Instagram
                </span>
                <span className="block mt-1 text-sm sm:text-base text-mist">
                  Pensieri sulla mediazione, sulla genitorialità e sulle seconde possibilità.
                </span>
              </span>
              <ArrowUpRight size={22} className="sm:ml-auto text-golddeep group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
            </a>
          </Reveal>
        )}
      </div>
    </section>
  );
};
